<ng-container *rxLet="state$ as state">
  <section class="business-details" data-test-id="user-profile-business-details-container">
    <h4 class="font-bold">Business details</h4>
    @if (!state.businessDetailsLoading) {
      @if (state.businessDetails) {
        <labeled-edit
          [canEdit]="state.canEdit"
          [fieldValue]="state.businessDetails?.CompanyName"
          [maxlength]="MAX_LENGTHS.company_name"
          [multilineTooltip]="true"
          [tooltipHtml]="'Legal name of your<br/>business/self-employment.'"
          (serverError)="onServerError()"
          (updateSuccess)="businessDetailsCompanyNameUpdated($event)"
          class="company-name"
          data-test-id="user-profile-businessNameEdit-container"
          label="Business name"
          placeholder="Enter legal name of your company"
          type="text"
          updateMethodName="updateCompanyNameProfile"
        ></labeled-edit>
        <labeled-edit
          [canEdit]="state.canEdit"
          [fieldValue]="state.businessDetails?.CompanyWebsite"
          [maxlength]="MAX_LENGTHS.website"
          (serverError)="onServerError()"
          (updateSuccess)="businessDetailsCompanyWebsiteUpdated($event)"
          class="company-website"
          data-test-id="user-profile-websiteEdit-container"
          display="url"
          label="Professional website"
          placeholder="e.g. http://www.mywebsite.com"
          type="url"
          updateMethodName="updateCompanyWebsiteProfile"
        ></labeled-edit>
      } @else {
        <no-data></no-data>
      }
    } @else {
      <div class="flex flex-center-start w-full h-full">
        <loader color="primary"></loader>
      </div>
    }
  </section>
</ng-container>
